// Nonce de navegador para el flujo de verificacion de email.
//
// Se genera al registrar (o al reenviar el correo) y se guarda en una cookie en
// ESTE navegador; ademas viaja en el link del mail (param `av`). Al abrir el
// link, Verify.tsx compara la cookie con el `av` del link: si matchean es el
// mismo navegador (web) → auto-login; si no, el mail se abrio en otro
// dispositivo (app/TV) → solo verificar.

export function makeVerifyNonce(): string {
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  return Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
}

export function setVerifyCookie(nonce: string): void {
  // SameSite=Lax: el click del link del mail es una navegacion top-level GET,
  // asi que la cookie viaja. 30 min de ventana de verificacion.
  document.cookie = `av=${nonce}; Max-Age=1800; Path=/; SameSite=Lax${
    window.location.protocol === 'https:' ? '; Secure' : ''
  }`;
}
